export default __webpack_public_path__ + "static/media/02_photo.f5f6ea11.jpeg";